




































































import { Component, Prop, Ref, Vue } from 'vue-property-decorator';
import SliderList from './SliderList.vue';
import DetailsWrap from './DetailsWrap.vue';
import { Position, WidgetType } from '@/models/Enums';
import ProductList from './ProductList.vue';
import { Action, Getter, Mutation, State } from 'vuex-class';
import { ApiModel, DetailsModel } from '@/models/Product';
import ShopLiteDetails from '@/components/local-shops/ShopLiteDetails.vue';
import { ShopInfoModel } from '@/models/ShopDetails';
import Location from '@/components/local-shops/Location.vue';
import { ILoadProducts } from '@/models/Parameters';
import WidgetTitle from '@/components/WidgetTitle.vue';

@Component({
  components: {
    ProductList,
    SliderList,
    DetailsWrap,
    ShopLiteDetails,
    Location,
    WidgetTitle,
  },
})
export default class PvglWrap extends Vue {
  @Prop() private pk!: string;
  @Prop() private type!: WidgetType;
  @Prop() private position!: Position;
  @Getter private products!: (type: string) => ApiModel[];
  @Getter private activeIndex!: (type: string) => number;
  @Getter private productDetails!: (type: string) => DetailsModel;
  @Getter private liteProducts!: ShopInfoModel[];
  @Mutation private setActiveProduct!: (data: any) => void;
  @Mutation private setStateLocation!: (data: string | null) => void;
  @Action private loadProducts!: (data: ILoadProducts) => void;
  @State(state => state.location.location) private location!: string | null;
  @Ref() private readonly locationComponent!: Location;
  private forcedLoc = '';
  private readonly locationKey = 'widgetLocation';

  private async locationChosen(loc: string) {
    this.setManualLoc(loc);
    await this.loadProducts({ id: this.pk, type: this.type, extra: this.forcedLoc });
    this.locationComponent.updateLocation();
    this.setStoredLocation(this.location);
  }
  private getStoredLocation() {
    if (!localStorage) {
      return null;
    }
    return localStorage.getItem(this.locationKey);
  }
  private setStoredLocation(value: string | null) {
    if (!localStorage) {
      return;
    }
    if (value == null) {
      localStorage.removeItem(this.locationKey);
    } else {
      localStorage.setItem(this.locationKey, value);
    }
  }
  private get myProductDetails() {
    return this.productDetails(this.type);
  }
  private get myProducts() {
    return this.products(this.type);
  }
  private get myActiveIndex() {
    return this.activeIndex(this.type);
  }
  private get isLocalShop() {
    return this.type === WidgetType.LocalShop;
  }
  private get isShowingLocalShop() {
    return this.isLocalShop && (this.myProducts.length > 0 || this.liteProducts.length > 0);
  }
  private get isActive() {
    return this.myProducts.length > 0 && this.myProductDetails != null;
  }
  private get isLiteShop() {
    return !this.isActive && this.type === WidgetType.LocalShop && this.liteProducts.length > 0;
  }
  private get wrapperClasses() {
    return { 'pvgl-wrap': true, normal: this.isCenter, small: !this.isCenter };
  }

  private get isCenter() {
    return this.position === Position.Center;
  }
  // noinspection JSUnusedGlobalSymbols
  private async created() {
    try {
      if (this.isLocalShop) {
        this.createdLocalShopLocation();
        await this.loadProducts({ id: this.pk, type: this.type, extra: this.forcedLoc });
      } else {
        await this.loadProducts({ id: this.pk, type: this.type });
      }
      if (this.isActive || this.isLiteShop) {
        this.$emit('loaded');
      }
    } catch (e) {
      // do nothing
    }
  }

  private createdLocalShopLocation() {
    let lat: number;
    let long: number;
    const latVar = this.getQueryVariable('lat');
    const longVar = this.getQueryVariable('long');
    if (latVar != null && longVar != null) {
      lat = parseFloat(latVar);
      long = parseFloat(longVar);
      this.forcedLoc = `?latitude=${lat}&longitude=${long}`;
    } else {
      const storedLoc = this.getStoredLocation();
      this.setStateLocation(storedLoc);
      this.setManualLoc(storedLoc);
    }
  }
  private getQueryVariable(variable: string) {
    const query = window.location.search.substring(1);
    const vars = query.split('&');
    for (const tuple of vars) {
      const pair = tuple.split('=');
      if (pair[0] === variable) {
        return pair[1];
      }
    }
    return null;
  }
  private setManualLoc(value: string | null): void {
    if (value != null && value.length > 0) {
      this.forcedLoc = `?manualLoc=${value}`;
    } else if (this.getProfileLocation() !== null) {
      this.forcedLoc = `?manualLoc=${this.getProfileLocation()}`;
    } else {
      this.forcedLoc = '';
      this.setStoredLocation(null);
    }
  }
  private getProfileLocation(): string | null {
    const dkVariables = (window as any).dkVars;
    if (dkVariables && dkVariables.widgetLocation != null && dkVariables.widgetLocation.length > 0) {
      return dkVariables.widgetLocation;
    }
    return null;
  }
  private onProductSelected(id: string, currentIndex: number, newIndex: number): void {
    this.setActiveProduct({ id, currentIndex, newIndex, position: this.position, type: this.type });
  }
}
